import React from 'react';
import { motion } from 'framer-motion';
import { FileSearch, Brain, PhoneCall, SmartphoneNfc, CalendarCheck } from 'lucide-react';
const steps = [{
  icon: FileSearch,
  title: 'AI Screen Resumes for Experience Fit',
  description: 'AI automatically reviews every application against your specific experience requirements — years on the road, route types, safety record, and more.'
}, {
  icon: Brain,
  title: 'Psychometric Evaluation',
  description: 'Candidates receive a safety-focused psychometric assessment to evaluate risk awareness, decision-making, and driver temperament — ensuring a safe driver profile.'
}, {
  icon: PhoneCall,
  title: 'AI Phone Screen',
  description: 'Our AI calls each candidate to verify details, fill in gaps, and ask follow-up questions — no human time required until the final stage.'
}, {
  icon: SmartphoneNfc,
  title: 'Shortlist Sent to Your Phone',
  description: 'Fully vetted, ranked candidates are pushed directly to your phone for quick review and approval. Accept or pass with a single tap.'
}, {
  icon: CalendarCheck,
  title: 'Interview Automatically Scheduled',
  description: 'Once you approve a candidate, Lighthouse AI handles scheduling — coordinating availability and sending confirmations to both sides.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-92">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-display font-bold text-slate-900 mb-4" data-id="element-93">
            From Application to Interview — Fully Automated
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-94">
            Five steps. Zero manual work. Here's how Lighthouse AI transforms
            your driver hiring pipeline.
          </motion.p>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-95">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.12
        }} className="relative flex gap-6 pb-12 last:pb-0" data-id="element-96">
              {/* Vertical connector line */}
              {index < steps.length - 1 && <div className="absolute left-7 top-16 bottom-0 w-0.5 bg-slate-200" data-id="element-97" />}

              {/* Step number + icon */}
              <div className="relative shrink-0" data-id="element-98">
                <div className="w-14 h-14 rounded-2xl bg-slate-900 flex items-center justify-center shadow-lg shadow-slate-900/10" data-id="element-99">
                  <step.icon className="w-7 h-7 text-blue-500" data-id="element-100" />
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-blue-500 text-white font-bold flex items-center justify-center text-xs border-2 border-white" data-id="element-101">
                  {index + 1}
                </div>
              </div>

              {/* Content */}
              <div className="pt-1" data-id="element-102">
                <h3 className="text-xl font-display font-bold text-slate-900 mb-2" data-id="element-103">
                  {step.title}
                </h3>
                <p className="text-slate-600 leading-relaxed" data-id="element-104">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}